import { inject, Injectable } from "@angular/core";
import { BehaviorSubject, map, Observable } from "rxjs";
import { ApiDataService } from "src/app/api/services/api-data.service";
import { CrudService } from "src/app/controls/base/crud-service.interface";
import { ColumnDefinition } from "src/app/controls/grid/models/column-definition.interface";
import { GridDataProvider } from "src/app/controls/grid/services/grid-data-provider.interface";
import { AnnualRegistration } from "../models/annual-registration.interface";
import { SelectedItem } from "src/app/controls/models/selected-item.interface";
import { CompetitionRegistrationCrew } from "../../navigation-bar/competitions/competition-details/competition-registration/models/competition-registration-crew.interface";
import { AnnualRegistrationList } from "../models/annual-registration-list.interface";

@Injectable({
    providedIn: 'root'
})
export class AnnualRegistrationsTableService implements GridDataProvider, CrudService<AnnualRegistration> {

    /** Api data service reference */
    private service = inject(ApiDataService);

    /** Grid reload emit reference */
    public reload = new BehaviorSubject<void>(undefined);
    
    /** @inheritdoc */
    public getTableName(seasonId: number): Observable<unknown> {
        return this.service.get<unknown>('seasons/get-name/' + seasonId).pipe(map((seasonName: unknown) => {
            return { name: 'CEC ' + seasonName['name'] };
        }));
    }

    /** @inheritdoc */
    public getGridData(seasonId: number): Observable<AnnualRegistrationList[]> {
        return this.service.getAll<AnnualRegistrationList>('annual-registrations/season/' + seasonId);
    }

    /** @inheritdoc */
    public getColumnDefinition(seasonId: number): Observable<ColumnDefinition[]> {
        return this.service.getAll<ColumnDefinition>('annual-registrations/column-definition/' + seasonId);
    }

    /** @inheritdoc */
    create(entity: AnnualRegistration): Observable<number> {
        return this.service.post('annual-registrations/create', entity);
    }
    
    /** @inheritdoc */
    update(entity: unknown): Observable<boolean> {
        throw new Error("Method not implemented.");
    }
    
    /** @inheritdoc */
    get(params?: unknown): Observable<AnnualRegistration> {
        throw new Error("Method not implemented.");
    }

    /**
     * Gets all available crews for creating a new annual registration
     * @returns the list of available crews
     */
    public getAvailableCrews(): Observable<SelectedItem[]> {
        return this.service.getAll<SelectedItem>('annual-registrations/available-crews');
    }

    public getCompetitors(crewId: number): Observable<CompetitionRegistrationCrew> {
        return this.service.get<CompetitionRegistrationCrew>('crews/registration/' + crewId);
    }

    /**
     * Gets the name of the active season
     * @returns the name of the active season
     */
    public getActiveSeasonName(): Observable<string> {
        return this.service.get<string>('seasons/get-active-name');
    }

    /**
     * Gets the id of the active season
     * @returns the id of the active season
     */
    public getActiveSeasonId(): Observable<number> {
        return this.service.get<number>('seasons/get-active-id');
    }
}